import React from 'react';
import { observer } from 'mobx-react';

import {
  API_FAILED,
  API_FETCHING,
  API_INITIAL,
  API_SUCCESS
} from '@nw/api-constants';
import {
  ERROR,
  getAPIErrorMessage,
  IDLE,
  LOADING,
  SUCCESS
} from '@nw/shared/utils';

import { FailureView } from './FailureView';
import { LoadingView } from './LoadingView';

type LoadingConfig = {
  variant: 'default' | 'contextual';
  texts?: string[];
  interval?: number;
  textAnimation?: 'fade-in-out';
  loadingLogo?: any;
};

interface LoadingWrapperTypes {
  apiStatus: number | string;
  renderSuccessUI: () => React.ReactElement | null;
  renderFailureUI?: () => React.ReactElement | null;
  onRetry: () => void;
  apiError: Error | null | string;
  loadingConfig?: LoadingConfig;
}

@observer
class LoadingWrapperWithFailure extends React.Component<LoadingWrapperTypes> {
  override render() {
    const {
      apiStatus,
      renderSuccessUI: RenderSuccessUI,
      renderFailureUI: RenderFailureUI,
      onRetry,
      apiError
    } = this.props;
    const errorMessage = getAPIErrorMessage(apiError);

    switch (apiStatus) {
      case API_INITIAL:
      case API_FETCHING:
      case LOADING:
      case IDLE:
        return <LoadingView loadingConfig={this.props.loadingConfig} />;
      case API_SUCCESS:
      case SUCCESS:
        return <RenderSuccessUI />;
      case API_FAILED:
      case ERROR: {
        if (RenderFailureUI) return <RenderFailureUI />;
        return (
          <FailureView onRetryClick={onRetry} errorMessage={errorMessage} />
        );
      }
      default:
        return null;
    }
  }
}

export {
  LoadingWrapperWithFailure,
  FailureView,
  LoadingView,
  LoadingConfig,
};
